import { Component } from '@angular/core';
import { PrivacyPolicyComponent } from '../privacy-policy.component';

@Component({
    selector: 'app-privacy-policy-page',
    imports: [
        PrivacyPolicyComponent
    ],
    templateUrl: './privacy-policy-page.component.html',
    styleUrl: './privacy-policy-page.component.scss'
})
export class PrivacyPolicyPageComponent {

}
